/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import getEnvironment from "utils/getEnvironment";

const { apiUrl: ENDPOINT, apiToken: token } = getEnvironment();

const formatBytes = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(0)) + " " + sizes[i];
};

const formatName = (name) => {
  if (name.length < 14) return name;
  else return name.substring(0, 10) + ".." + name.substring(name.length - 4);
};

function FileUploaderAuto({
  description,
  patchName,
  result: propsResult,
  firstname,
  lastname,
}) {
  const [fileSelected, setFileSelected] = useState(false);
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [file, setFile] = useState({
    name: "",
    date: "",
    size: "",
  });

  const handleFile = (e) => {
    let content = e.target.result;
    content = content.split(",")[1];

    const bodyData = {
      transaction_id: propsResult.data.transaction_id,
      fileImposition: content,
      user_firstname: firstname,
      user_lastname: lastname,
    };

    const url = `${ENDPOINT}/updatetransaction`;
    setLoading(true);
    fetch(url, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify(bodyData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return response.json();
      })
      .then((newResult) => {
        setResult(newResult);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFileInfo = (selectedFile) => {
    const filedate = new Date(selectedFile.lastModifiedDate);
    const options = { year: "numeric", month: "long", day: "numeric" };

    setFile({
      date: filedate.toLocaleDateString("fr-FR", options),
      name: selectedFile.name,
      size: formatBytes(selectedFile.size),
    });
    setFileSelected(true);
  };

  const handleChangeFile = (selectedFile) => {
    handleFileInfo(selectedFile);
    const fileReader = new FileReader();
    fileReader.onloadend = handleFile;
    fileReader.readAsDataURL(selectedFile);
  };

  return (
    <div className="pv-10">
      <div className="file-uploader-container">
        <div className="align-center">
          <div className="uploader-paragraph">
            <p>{description}</p>
          </div>

          <label className="btn-file-uploader is-bold">
            <input
              type="file"
              accept=".pdf"
              name={patchName}
              onChange={(e) =>
                handleChangeFile(e.target.files[0], e.target.name)
              }
              style={{ opacity: 0 }}
            />
            Ajouter un document
            <span className="iconColor1">
              <svg
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="ml-10"
              >
                <path
                  d="M3.03223 4.12977L3.9466 5.05102L6.35286 2.66883V8.60197H7.6488V2.66883L10.0516 5.05102L10.966 4.12977L6.99911 0.197266L3.03223 4.12977Z"
                  fill="#006FBA"
                />
                <path
                  d="M13.8666 12.8019H0.133789V6.85156H1.51223V11.4166H12.4882V6.85156H13.8666V12.8019Z"
                  fill="#006FBA"
                />
              </svg>
            </span>
          </label>
        </div>
        <div className="mv-10"></div>
        <div>
          {fileSelected && (
            <div>
              <p
                style={{
                  fontSize: "10px",
                  textAlign: "left",
                }}
                className="mt-20"
              >
                1 fichier importé
              </p>
              <hr className="light-hr" />
              <div style={{ fontSize: "12px" }}>
                <span>{formatName(file.name)}</span>
                <span style={{ float: "right", color: "rgba(58, 58, 58, 1)" }}>
                  {file.date} - {file.size}
                </span>
              </div>
            </div>
          )}

          <div style={{ height: "20px" }} className="align-right">
            {result?.success && !loading && (
              <p className="text-xs text-green">
                Votre avis d'imposition est bien reçu!
              </p>
            )}
            {loading && <span className="loader"></span>}
            {error && !loading && (
              <p className="text-red text-xs">
                Erreur de chargement de votre avis d'imposition
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FileUploaderAuto;
